class BatchService {
  constructor($http, config) {
    this.$http = $http;
    this.config = config;
  }

  createBatch(fileSource, forceSync, isUnManaged, batchConfig = null, file = null) {
    let url = isUnManaged ? `${this.config.apiRoot}/upload/${batchConfig.uploaderRole}/users/${batchConfig.uploaderXid}` : `${this.config.apiRoot}/batches`;
    const formData = new FormData();
    formData.append('fileSource', fileSource);
    formData.append('file', file);
    formData.append('forceSync', forceSync);
    if (isUnManaged){
      formData.append('organizationXid', batchConfig.organizationXid);
      if(batchConfig.sectionXid){
        formData.append('sectionXid', batchConfig.sectionXid);
      }
    }
    return this.$http.post(url, formData, {
      headers: {
        'Content-Type': undefined
      }
    });
  }

  getWorkflowDefinitions(customerAction) {
    let url = `${this.config.apiRoot}/workflowDefinitions?customerAction=${customerAction}`;
    return this.$http.get(url);
  }

  updateBatch(batch) {
    let url = `${this.config.apiRoot}/batches/${batch.id}`;
    return this.$http.put(url, {
      batch
    });
  }

  getBatch (batchId) {
    let url = `${this.config.apiRoot}/batches/${batchId}`;
    return this.$http.get(url, {});
  }

  cancelBatch(batchId) {
    let url = `${this.config.apiRoot}/batches/${batchId}/cancel`;
    return this.$http.put(url, {cache: false});
  }
}

BatchService.$inject = ['$http', 'config'];

export default BatchService;



// WEBPACK FOOTER //
// ./app/common/batch/batch.service.js